module.exports = {
    aguardandoAutorizador: 'Encaminhado',
    aguardandoOperador: 'Novo',
    alteracaoApac: 'Alteração de processo de APAC',
    alterarAutorizador: 'Alterar autorizador',
    alterarDataValidade: 'Alterar data de validade',
    alterarNumeroApac: 'Alterar número da APAC',
    anexosObrigatoriosApacContinuidade: 'A adição do laudo da APAC é obrigatória',
    anexosObrigatoriosNovaApacOutrosProcedimentos: 'A adição do histórico (SGPe), do laudo da APAC, dos exames, do SISREG e dos documentos pessoais é obrigatória',
    anexosObrigatoriosNovaApacPETCT: 'O laudo da APAC, dos exames, do SISREG e dos documentos pessoais é obrigatória',
    anoMesProcedencia: 'Ano e mês de procedência',
    apacContinuidade: 'APAC continuidade',
    apacPadrao: 'Solicitação padrão',
    atencaoAdicaoAnexos: (tipoSolicitacao) =>
        tipoSolicitacao === 'P'
            ? 'Anexe aqui o processo: histórico do SGPe, laudo médico, exames obrigatórios, comprovante do SISREG e documentos pessoais (RG, CPF, comprovante de residência). Todos são obrigatórios.'
            : 'Anexe aqui o processo: laudo médico (obrigatório) e exames complementares (não obrigatório).',
    atencaoAdicaoAnexosGerais: 'Anexe aqui os exames obrigatórios e os demais documentos do paciente.',
    autorizacao: 'Autorização',
    autorizado: 'Aprovado',
    autorizadoAdministrador: 'Autorizado pelo administrador',
    autorizadoOperador: 'Autorizado pelo operador',
    autorizadoPeloMedicoAutorizador: 'Autorizado',
    avisoPossibilidadeTransplante: 'A opção "Transplante" agora está habilitada na seção "Procedência do pedido"',
    cancelado: 'Cancelado',
    cancelamento: 'Cancelamento',
    carregandoInstituicoesAutorizadoras: 'Carregando instituições autorizadoras',
    carregandoInstituicoesSolicitantes: 'Carregando instituicões solicitantes',
    cid10Secundario: 'CID-10 Secundário',
    cidadeAutorizadora: 'Cidade autorizadora',
    cidadeSolicitante: 'Cidade solicitante',
    cnsPaciente: 'CNS do paciente',
    codigoProcedimento: 'Código do procedimento',
    comNumero: 'Com número',
    complementoProcedencia: 'Complemento da procedência',
    complexosRegulatorios: 'Complexos regulatórios',
    confirmacaoSolicitarNumeroApac: 'Você deseja solicitar um número para este processo de APAC?',
    confirmarAutorizacao: 'Confirma a autorização deste processo?',
    confirmarSalvarFuncionariosComplexoRegulatorio: 'Você deseja vincular estes autorizadores ao complexo regulatório escolhido?',
    cpfPaciente: 'CPF do paciente',
    dadosProcedimento: 'Dados do procedimento',
    dadosSigtap: 'Dados SIGTAP',
    dataAutorizacao: 'Data da autorização',
    dataFinalAutorizacao: 'Data final da autorização',
    dataFinalValidade: 'Data final de validade',
    dataGeracaoNumeroApac: 'Data de geração do número da APAC',
    dataInicialAutorizacao: 'Data inicial da autorização',
    dataSolicitacaoLaudo: 'Data de solicitação do laudo',
    dataValidade: 'Data de validade',
    descricaoProcedimento: 'Descrição do procedimento',
    desmarcarTodos: 'Desmarcar todos',
    devolucao: 'Devolução',
    devolvendoNumeroApac: 'Devolvendo número da APAC',
    devolverNumeroApac: 'Devolver o número para a lista',
    devolverOperador: 'Operador',
    devolverSolicitante: 'Solicitante',
    devolvido: 'Devolvido',
    emAnalise: 'Análise',
    encaminharAutorizador: 'Encaminhar ao autorizador',
    erroAlterarSolicitacao: 'Houve um erro ao editar a solicitação da APAC. Tente novamente mais tarde.',
    erroCadastrarProcedimento: 'Ocorreu um erro ao cadastrar o(s) procedimento(s)',
    erroDevolverNumeroApac: 'Ocorreu um erro ao devolver o número da APAC',
    erroImprimirProcesso: 'Ocorre um erro ao imprimir o processo. Tente novamente mais tarde.',
    erroIniciarNovaSolicitacao: 'Não foi possível inicializar a solicitação de APAC. Tente novamente mais tarde.',
    erroInvalidarNumeroApac: 'Ocorreu um erro ao invalidar o número da APAC',
    erroPesquisaProcedimentoSigtap: 'Houve um erro na busca de procedimentos SIGTAP. Tente novamente mais tarde.',
    erroRecuperacaoFuncionarioComplexoRegulatorio: 'Ocorreu um erro ao recuperar os funcionários do complexo regulatório. Por favor, tente mais tarde.',
    erroRecuperacaoMotivoCancelamento: 'Ocorreu um erro ao recuperar os motivos de cancelamento. Por favor, tente mais tarde.',
    erroRecuperacaoMotivoDevolucao: 'Ocorreu um erro ao recuperar os motivos de devolução. Por favor, tente mais tarde.',
    erroSolicitarNumeroApac: 'Ocorreu um erro ao gerar o número para este processo',
    examesComplementares: 'Exames complementares',
    faixaApac: 'Faixa da APAC',
    faixaGeral: 'Geral',
    faixaOci: 'OCI',
    fecharTodosHistoricos: 'Fechar todos os históricos',
    filtroProcedimento: 'Filtro por procedimento',
    folhaAutorizacao: 'Folha de autorização do sistema de controle AC',
    funcionarioAdministrador: 'Funcionário administrador',
    funcionarioAutorizador: 'Funcionário autorizador',
    funcionarioSolicitante: 'Funcionário solicitante',
    gerandoNumeroApac: 'Gerando número de APAC',
    imprimindoApac: 'Imprimindo processo de APAC',
    informeApacContinuidade:
        'Detectamos que já existem processos de mesmo procedimento e unidade executora para este paciente. Você poderá marcar esta solicitação como do tipo continuidade, se desejar',
    informeApacOci: 'Detectamos que a solicitação se refere a uma OCI (Ofertas de Cuidados Integrados) e, portanto, a mesma deve ser do tipo "Padrão"',
    informeApacPadrao: 'Detectamos que esta é a primeira solicitação do paciente para este procedimento e unidade executora. Esta solicitação foi marcada como sendo do tipo padrão',
    iniciandoSolicitacao: 'Iniciando solicitação',
    instituicaoAutorizadora: 'Instituição autorizadora',
    instituicaoExecutora: 'Instituição executora',
    instrucaoVinculoAutorizadorComplexoRegulatorio: `<span>- Parametrização dos profissionais autorizadores nos complexos regulatórios.</span>
                                <span>- A partir dessa tela, é possível realizar o cadastro dos profissionais autorizadores nos diferentes complexos regulatórios do sistema.</span>
                                <span>- A partir dessa tela, também é possível descadastrar o profissional de um complexo regulatório previamente cadastrado.</span>`,
    invalidado: 'Invalidado',
    invalidandoNumeroApac: 'Invalidando número da APAC',
    invalidar: 'Invalidar',
    invalidarNumeroApac: 'Invalidar número da APAC',
    justificativa: 'Justificativa',
    justificativaProcedimento: 'Justificativa do procedimento',
    justificativaSolicitacao: 'Justificativa da solicitação',
    liberacaoUnacon: 'Conforme DELIBERAÇÃO 092/CIB/2019 - A inserção dos pedidos de PET-CT no módulo ambulatorial, deve ser feita pela Unidade Hospitalar solicitante (UNACON/CACON).',
    medicoAutorizador: 'Médico autorizador',
    mensagemAberturaProcesso: 'Você deseja iniciar uma nova solicitação de APAC? Ao confirmar, um novo rascunho será criado.',
    mensagemCadastroOci: 'Você está cadastrando procedimentos OCI para uma outra faixa da APAC. Tem certeza que deseja continuar?',
    mensagemCadastroProcedimento: 'Você deseja cadastrar estes procedimentos?',
    mensagemDevolucao: 'Para quem você deseja devolver este processo?',
    mensagemOperacao: 'Deseja realizar esta operação?',
    mensagemOperacao: 'Deseja realizar esta operação?',
    mensagemOperacaoAprovacao: 'Deseja aprovar esta solicitação?',
    mensagemOperacaoAutorizacao: 'Deseja autorizar esta solicitação?',
    motivoDevolucaoPadrao: `                Trata-se de reivindicação, ao SUS, de exame tipo tomografia por emissão de pósitrons (PET-CT ou PET Scan), por (preencher o diagnóstico da doença). A matéria é regida pela Portaria 1.340, de 1º. de dezembro de 2014, do Ministério da Saúde. A PET-CT não é um exame para rastreamento, para confeccionar um primeiro diagnóstico, para mera investigação inicial da existência ou não de implantes secundários, nem para fazer diagnóstico diferencial em situações duvidosas. Ela amplia e refina as informações sobre diagnósticos já confirmados através de outros métodos.
                                Não houve aprovação pela Comissão Nacional de Incorporação de Tecnologias pelo SUS (CONITEC) à incorporação da tecnologia em casos deste tipo, com este diagnóstico, por precariedade de evidências científicas favoráveis quanto à sua eficácia, eficiência e efetividade. Há outras investigações pelas quais a PET-CT pode ser intercambiada. O procedimento, portanto, neste caso, não pode ser realizado pelo SUS. É substituível por outros exames disponíveis.
                                Não há protocolo aprovado pelo Ministério da Saúde, concedendo o exame, para a indicação diagnóstica constante no pedido atual, pois ela não está coberta pelas portarias nos. 7 e 9, de 22 de abril de 2014, nem pela portaria no. 8, de 14 de abril de 2014, da Secretaria de Ciência, Tecnologia e Insumos Estratégicos do Ministério da Saúde. O procedimento, para este diagnóstico, não está padronizado na Tabela SIGTAP ou nas listas de procedimentos aprovadas na Comissão Intergestores Tripartite, atuante em Brasília. O pedido não cabe na Portaria 1.340, de 01/12/2014 do Ministério da Saúde. Sua concessão feriria, pois, o Art. 19-M da Lei 8.080/90.
                                A PET-CT, para esta indicação, além de não fazer parte da RENASES, não compõe as listas de procedimentos do SUS. Para incluí-la no rol dos procedimentos, caso venham a ocorrer novos dados científicos, as entidades de pesquisa precisarão montar e aprovar processo, junto à CONITEC, no Ministério da Saúde, em Brasília, segundo os ditames do Decreto no. 7.646, de 21 de dezembro de 2011, da Lei no. 12.401, de 28/04/2011 e da Lei 8.080 de 19 de setembro de 1990. Não cabe, pois, ao Executivo Estadual, ao Judiciário, ou a Prefeituras realizar a incorporação desta tecnologia ao sistema público de saúde, de forma alheia à Comissão Nacional de Incorporação de Tecnologias (CONITEC) e de forma alheia à legislação.`,
    necessitaAnexo: 'Ao menos um anexo é obrigatório',
    necessitaLaudoMedicoExamesComplementares: 'A adição do laudo médico e do exame complementar é obrigatória',
    nenhumaSolicitacaoContinuidade: 'Nenhuma solicitação de continuidade encontrada para este processo',
    nomeAutorizador: 'Nome do autorizador',
    novaSolicitacao: 'Nova solicitação',
    numeroAcaoJudicial: 'Número da ação judicial',
    numeroApac: 'Número da APAC',
    numeroAtendimentoUnacon: 'Número do atendimento na UNACON',
    numeroAutorizacaoControleAC: 'Número de autorização de controle AC',
    numeroSolicitacao: 'Número da solicitação',
    numeroSolicitacaoSisreg: 'Número de solicitação do SISREG',
    outros: 'Outros',
    pesquisaAPAC: 'Pesquisa de processos',
    pesquisaSolicitacoes: 'Pesquisa de solicitações',
    procedenciaPedido: 'Procedência do pedido',
    procedenciaProcesso: 'Procedência do processo',
    procedimentosSelecionados: 'Procedimentos selecionados',
    procedimentosSigtap: 'Procedimentos SIGTAP',
    processoApac: 'Processo de APAC',
    processoCancelado: 'Processo cancelado',
    processoDesabilitado: 'Não é possível selecionar esse processo',
    processoDevolvido: 'Processo devolvido',
    processoSelecionado: 'processo selecionado.',
    processosSelecionados: 'processos selecionados.',
    quantidade: 'Quantidade',
    rascunho: 'Rascunho',
    rascunhoSalvoSucesso: 'Rascunho salvo com sucesso',
    redesDeProcedimentos: 'Redes de procedimentos',
    resumoAnamnese: 'Resumo da anamnese e exame físico',
    resumoExameFisico: 'Resumo do exame físico',
    salvandoRascunho: 'Salvando rascunho',
    selecaoMultipla: 'Seleção múltipla',
    selecionarRestantes: 'Selecionar restante(s)',
    selecionarTodos: 'Selecionar todos',
    semNumero: 'Sem número',
    sequencialSemLetras: 'O número sequencial do processo não deve possuir letras',
    situacaoNumeroApac: 'Situação do número da APAC',
    solicitacaoEnviada: 'Solicitação enviada com sucesso.',
    solicitacaoLaudo: 'Solicitação do laudo',
    solicitacaoNovoApac: 'Solicitação de APAC',
    solicitacoesContinuidade: 'Solicitações de continuidade',
    solicitarNumeroApac: 'Solicitar número da APAC',
    sucessoOperacao: 'Operação realizada com sucesso',
    textoAlterarNumeroApac: 'Você está prestes a alterar o número da APAC para este processo. Por favor, escolha o que deseja fazer com o número de APAC atual:',
    textoConfirmarEdicaoSolicitacao: 'Deseja salvar os dados da alteração?',
    textoConfirmarEnvio: 'Deseja encaminhar a solicitação?',
    textoConfirmarRascunhoSolicitacao: 'Deseja salvar o rascunho da solicitação?',
    tipoProcesso: 'Tipo de processo',
    tipoSolicitacao: 'Tipo de solicitação',
    tooltipEncaminhamento24Horas: 'Atenção! Você tem menos de 24 horas para encaminhar este processo',
    tooltipEncaminhamento36Horas: 'Atenção! Você tem menos de 36 horas para encaminhar este processo',
    tooltipEncaminhamento48Horas: 'Você deve encaminhar este processo em até 48 horas',
    tooltipEncaminhamentoAtrasado: 'Atenção! O encaminhamento do processo está atrasado',
    transplante: 'Transplante',
    verificamosApacProcessoPaciente: 'Acesse AQUI o histórico de processos de APAC já aprovadas para esse paciente.',
    vinculoAutorizadorComplexosRegulatorios: 'Vínculo de autorizadores aos complexos regulatórios'
};
